module.exports = __webpack_public_path__ + "img/map-pl.0b7abf6a.png";